@if (form && fieldName) {
  <div [formGroup]="form">
    <p-select id="type" appendTo="body"
              [options]="countries"
              [placeholder]="placeholder | translate"
              [formControlName]="fieldName"
              (onChange)="selectedCountryCd = form.controls[fieldName].value; countryChanged($event.value);"
              [showClear]="showClear"
              [virtualScroll]="true"
              [virtualScrollItemSize]="34"
              [scrollHeight]="scrollHeight"
              (onShow)="onSelectShow()"
              optionLabel="name"
              optionValue="code"
              [filter]="true"
              [class]="'grid-comp-full-width'">
      <ng-template let-item #item>
        @if (item.code === '--') {
          <p-divider/>
        } @else {
          <div class="flex align-items-center gap-2">
            <span class="fi fi-{{item.code | lowercase}}"></span>
            {{item.name}}
          </div>
        }
      </ng-template>
      <ng-template let-item #selectedItem>
        <div class="flex align-items-center gap-2">
          <span class="fi fi-{{item.code | lowercase}}"></span>
          {{item.name}}
        </div>
      </ng-template>
    </p-select>
  </div>
}
@else {
  <p-select #countrySelect
            id="type" appendTo="body"
            [options]="countries"
            [placeholder]="placeholder | translate"
            [(ngModel)]="selectedCountry"
            (ngModelChange)="countryChanged($event)"
            [showClear]="showClear"
            [virtualScroll]="true"
            [virtualScrollItemSize]="34"
            [scrollHeight]="scrollHeight"
            (onShow)="onSelectShow()"
            optionLabel="name"
            [filter]="true"
            [class]="'grid-comp-full-width'">
    <ng-template let-item #item>
      @if (item.code === '--') {
        <p-divider/>
      } @else {
        <div class="flex align-items-center gap-2">
          <span class="fi fi-{{item.code | lowercase}}"></span>
          {{item.name}}
        </div>
      }
    </ng-template>
    <ng-template let-item #selectedItem>
      <div class="flex align-items-center gap-2">
        <span class="fi fi-{{item.code | lowercase}}"></span>
        {{item.name}}
      </div>
    </ng-template>
  </p-select>
}
